import React, { Component } from 'react';

class NoMatch extends Component {
  render() {
    return (
      <div>
        <h1>404 Page Not Found</h1>
      </div>
    );
  }
}

export default NoMatch;
